<template>
  <div class="card">
      <header class="card-header">
        <p class="card-header-title">
            {{name}}
        </p>
      </header>
      <div class="card-content">
        <figure class="image">
          <img :src="image(pjClass)" :alt="`MU Crisis ${charClass(pjClass)}`">
        </figure>
        <hr>
        <p class="title is-5 has-text-info">Información</p>
        <p class="is-size-6 has-text-grey-dark">
          <b>{{charClass(pjClass)}}</b>
          <br>
          {{reset}} Resets <br>
          {{grandreset}} GrandResets
          <br>
          Lvl.{{level}}
          <br>
          <span v-if="pk>0" class="has-text-danger">Asesino</span>
          <span v-else-if="pk<0" class="has-text-link">Héroe</span>
          <span v-else>Normal</span>
          <br>
          <span v-if="vip>0" class="has-text-link"><fa icon="award" /> VIP</span>
          <br>
        </p>
        <hr>
        <p class="title is-5 has-text-grey">Estadísticas</p>
        <div class="content has-text-left">
          <ul>
            <li>Fuerza: {{str}}</li>
            <li>Agilidad: {{agi}}</li>
            <li>Vitalidad: {{vit}}</li>
            <li>Energía: {{ene}}</li>
          </ul>
        </div>
        <hr>
        <p class="title is-5 has-text-warning">Zen</p>
        <p class="subtitle is-6 has-text-dark">{{numberFormat(zen)}}</p>
      </div>
      <footer class="card-footer">
        <a @click="$emit('setReset',name)" class="card-footer-item has-text-danger">Reset</a>
        <a @click="$emit('addStat',name)" class="card-footer-item">Puntos</a>
      </footer>
  </div>
</template>

<script>
export default {
    name:'CharacterCard',
    props: {
        name: {
            default: '',
            type: String
        },
        pjClass: {
            default: 0,
            type: Number
        },
        reset: {
            default: 0,
            type: Number
        },
        grandreset: {
            default: 0,
            type: Number
        },
        level: {
            default: 0,
            type: Number
        },
        pk: {
            default: 0,
            type: Number
        },
        str: {
            default: 25,
            type: Number
        },
        agi: {
            default: 25,
            type: Number
        },
        vit: {
            default: 25,
            type: Number
        },
        ene: {
            default: 25,
            type: Number
        },
        zen: {
            default: 0,
            type: Number
        },
        vip: {
            default: 0,
            type: Number
        }
    },
    computed: {
      charClass() {
          return this.$store.getters.GetCharacterBreed
      },
      image() {
        return this.$store.getters.getCharacterImage
      },
      numberFormat() {
        return this.$store.getters.numberWithCommas
      }
    }
}
</script>